<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-2 tableName">
                  Packaging History
                </div>
                <div class="col-sm-12 col-md-7"></div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        class="form-control borderNone form-control-sm mr-3"
                        v-model="search"
                        v-on:keyup="filterResults()"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Brand: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Brand
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Material: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >
                          Type of material
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Size: activate to sort column ascending"
                          v-on:click="sortResults(4)"
                        >
                          Size
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Points: activate to sort column ascending"
                          v-on:click="sortResults(5)"
                        >
                          Green points
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Admin: activate to sort column ascending"
                          v-on:click="sortResults(7)"
                        >
                          Updated by
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Date: activate to sort column ascending"
                          v-on:click="sortResults(6)"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-for="(item, index) in items"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">{{ item.name }}</td>
                        <td>{{ item.brand }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.size }}</td>
                        <td>{{ item.greenpoints }}</td>
                        <td>{{ item.adminname }}</td>
                        <td>{{ item.createdon }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination
                :meta_data="meta_data"
                v-on:next="fetchResults"
              ></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      items: [],
      search: null,
      order: null,
      dir: 0,
      sort: null,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
      },
    };
  },
  mounted() {
    this.fetchResults(
      this.meta_data.current_page,
      this.meta_data.perpage,
      this.search,
      this.order,
      this.sort
    );
  },
  methods: {
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort
    ) {
      axios
        .get(store.state.BASE_URI + "admin/packaging/history", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
          },
        })
        .then((res) => {
          this.items = res.data.results.items;
          var pagination = res.data.results.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.order = pagination.order;
        });
    },
    filterResults() {
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = "desc";
      else this.sort = "asc";
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
  },
};
</script>

<style src="../css/style.css"></style>
